import anthropicAvatar from './anthropic/avatar.png';
import anthropicLogo from './anthropic/logo.png';
import arizeAvatar from './arize/avatar.png';
import arizeLogo from './arize/logo.png';
import auth0Avatar from './auth0/avatar.png';
import auth0Logo from './auth0/logo.png';
import awsLambdaAvatar from './aws-lambda/avatar.png';
import awsLambdaLogo from './aws-lambda/logo.png';
import azureOpenaiAvatar from './azure-openai/avatar.png';
import azureOpenaiLogo from './azure-openai/logo.png';
import bigcommerceAvatar from './bigcommerce/avatar.png';
import bigcommerceLogo from './bigcommerce/logo.png';
import commercelayerAvatar from './commerce-layer/avatar.png';
import commercelayerLogo from './commerce-layer/logo.png';
import contentfulAvatar from './contentful/avatar.png';
import contentfulLogo from './contentful/logo.png';
import elasticpathAvatar from './elasticpath/avatar.png';
import elasticpathLogo from './elasticpath/logo.svg';
import faunaAvatar from './fauna/avatar.png';
import faunaLogo from './fauna/logo.png';
import googleVertexAvatar from './google-vertex/avatar.png';
import googleVertexLogo from './google-vertex/logo.png';
import gorgiasAvatar from './gorgias/avatar.svg';
import gorgiasLogo from './gorgias/logo.svg';
import graphqlAvatar from './graphql/avatar.png';
import graphqlLogo from './graphql/logo.png';
import groqAvatar from './groq/avatar.png';
import groqLogo from './groq/logo.svg';
import hygraphAvatar from './hygraph/avatar.png';
import hygraphLogo from './hygraph/logo.png';
import judgeMeAvatar from './judge-me/avatar.jpg';
import judgeMeLogo from './judge-me/logo.svg';
import klaviyoAvatar from './klaviyo/avatar.png';
import klaviyoLogo from './klaviyo/logo.png';
import loyaltylionAvatar from './loyaltylion/avatar.png';
import loyaltylionLogo from './loyaltylion/logo.png';
import mailchimpAvatar from './mailchimp/avatar.png';
import mailchimpLogo from './mailchimp/logo.png';
import netlifyAvatar from './netlify/avatar.png';
import netlifyLogo from './netlify/logo.png';
import notionAvatar from './notion/avatar.png';
import notionLogo from './notion/logo.png';
import oidcAvatar from './oidc/avatar.png';
import oidcLogo from './oidc/logo.png';
import olyslagerAvatar from './olyslager/avatar.png';
import olyslagerLogo from './olyslager/logo.png';
import openAiAvatar from './openai/avatar.svg';
import openAiLogo from './openai/logo.svg';
import openapiAvatar from './openapi/avatar.png';
import openapiLogo from './openapi/logo.png';
import petfinderAvatar from './petfinder/avatar.png';
import petfinderLogo from './petfinder/logo.png';
import postscriptAvatar from './postscript/avatar.jpg';
import postscriptLogo from './postscript/logo.png';
import rechargeAvatar from './recharge/avatar.png';
import rechargeLogo from './recharge/logo.png';
import restAvatar from './rest/avatar.png';
import restLogo from './rest/logo.png';
import reviewsIoAvatar from './reviews-io/avatar.png';
import reviewsIoLogo from './reviews-io/logo.png';
import riseAiAvatar from './rise-ai/avatar.png';
import riseAiLogo from './rise-ai/logo.jpg';
import salsifyAvatar from './salsify/avatar.png';
import salsifyLogo from './salsify/logo.png';
import sanityAvatar from './sanity/avatar.png';
import sanityLogo from './sanity/logo.svg';
import shipEngineAvatar from './ship-engine/avatar.png';
import shipEngineLogo from './ship-engine/logo.svg';
import shopifyAvatar from './shopify/avatar.png';
import shopifyLogo from './shopify/logo.png';
import shopifyStorefrontAvatar from './shopify-storefront/avatar.png';
import shopifyStorefrontLogo from './shopify-storefront/logo.png';
import stripeAvatar from './stripe/avatar.png';
import stripeLogo from './stripe/logo.png';
import submarineAvatar from './submarine/avatar.png';
import submarineLogo from './submarine/logo.png';
import syndigoAvatar from './syndigo/avatar.png';
import syndigoLogo from './syndigo/logo.png';
import takeshapeAvatar from './takeshape/avatar.png';
import takeshapeLogo from './takeshape/logo.png';
import unstructuredAvatar from './unstructured/avatar.png';
import vercelAvatar from './vercel/avatar.png';
import vercelLogo from './vercel/logo.png';
import voyageaiAvatar from './voyageai/avatar.jpg';
import voyageaiLogo from './voyageai/logo.svg';
import wordpressAvatar from './wordpress/avatar.png';
import wordpressLogo from './wordpress/logo.png';
import yelpAvatar from './yelp/avatar.png';
import yelpLogo from './yelp/logo.png';
import yotpoAvatar from './yotpo/avatar.jpg';
import yotpoLogo from './yotpo/logo.png';

/**
 * To be displayed in lists and at smaller sizes.
 * Should be 1:1.
 */
export const avatars: Record<string, string> = {
  auth0: auth0Avatar,
  awsLambda: awsLambdaAvatar,
  bigcommerce: bigcommerceAvatar,
  commercelayer: commercelayerAvatar,
  contentful: contentfulAvatar,
  fauna: faunaAvatar,
  hygraph: hygraphAvatar,
  graphql: graphqlAvatar,
  klaviyo: klaviyoAvatar,
  mailchimp: mailchimpAvatar,
  netlify: netlifyAvatar,
  notion: notionAvatar,
  oidc: oidcAvatar,
  openapi: openapiAvatar,
  petfinder: petfinderAvatar,
  rest: restAvatar,
  reviewsIo: reviewsIoAvatar,
  shopify: shopifyAvatar,
  shopifyStorefront: shopifyStorefrontAvatar,
  stripe: stripeAvatar,
  takeshape: takeshapeAvatar,
  vercel: vercelAvatar,
  yelp: yelpAvatar,
  judgeMe: judgeMeAvatar,
  shipEngine: shipEngineAvatar,
  elasticpath: elasticpathAvatar,
  loyaltylion: loyaltylionAvatar,
  salsify: salsifyAvatar,
  sanity: sanityAvatar,
  gorgias: gorgiasAvatar,
  yotpo: yotpoAvatar,
  postscript: postscriptAvatar,
  riseAi: riseAiAvatar,
  recharge: rechargeAvatar,
  wordpress: wordpressAvatar,
  openAi: openAiAvatar,
  voyageai: voyageaiAvatar,
  anthropic: anthropicAvatar,
  submarine: submarineAvatar,
  arize: arizeAvatar,
  unstructured: unstructuredAvatar,
  azureOpenai: azureOpenaiAvatar,
  googleVertex: googleVertexAvatar,
  syndigo: syndigoAvatar,
  olyslager: olyslagerAvatar,
  groq: groqAvatar
};

/**
 * The official logo of the brand, often a horizontal variant.
 * Should be 2:1.
 */
export const logos: Record<string, string> = {
  auth0: auth0Logo,
  awsLambda: awsLambdaLogo,
  bigcommerce: bigcommerceLogo,
  commercelayer: commercelayerLogo,
  contentful: contentfulLogo,
  fauna: faunaLogo,
  hygraph: hygraphLogo,
  graphql: graphqlLogo,
  klaviyo: klaviyoLogo,
  mailchimp: mailchimpLogo,
  netlify: netlifyLogo,
  notion: notionLogo,
  oidc: oidcLogo,
  openapi: openapiLogo,
  petfinder: petfinderLogo,
  rest: restLogo,
  reviewsIo: reviewsIoLogo,
  shopify: shopifyLogo,
  shopifyStorefront: shopifyStorefrontLogo,
  stripe: stripeLogo,
  takeshape: takeshapeLogo,
  vercel: vercelLogo,
  yelp: yelpLogo,
  judgeMe: judgeMeLogo,
  shipEngine: shipEngineLogo,
  elasticpath: elasticpathLogo,
  loyaltylion: loyaltylionLogo,
  salsify: salsifyLogo,
  sanity: sanityLogo,
  gorgias: gorgiasLogo,
  yotpo: yotpoLogo,
  postscript: postscriptLogo,
  riseAi: riseAiLogo,
  recharge: rechargeLogo,
  wordpress: wordpressLogo,
  openAi: openAiLogo,
  voyageai: voyageaiLogo,
  anthropic: anthropicLogo,
  submarine: submarineLogo,
  arize: arizeLogo,
  unstructured: unstructuredAvatar,
  azureOpenai: azureOpenaiLogo,
  googleVertex: googleVertexLogo,
  syndigo: syndigoLogo,
  olyslager: olyslagerLogo,
  groq: groqLogo
};
